@use '@/scss/underscore' as _;

.copyToClipboard {
  display: block;
}
